import { useParams } from '@tanstack/react-router';
import { PurchaseOrderMain } from '@/features/purchase-order/purchase-order-main';

export function PurchaseOrderMainPage() {
  const { id } = useParams({ strict: false });

  return <PurchaseOrderMain id={`${id}`} />;
}
